export default __webpack_public_path__ + "static/media/573.a266ba1a.gif";